import { twMerge } from 'tailwind-merge';

import NftCardLabelPanel from 'components/nftCard/_new/nftCardLabelPanel/NftCardLabelPanel';

import { ScreenSize, useScreenSize } from 'hooks/useScreenSize';

import RMV from 'assets/icons/RMV.png';

type NftPackageParamRowProps = {
  label: string;
  value: string;
  withIcon?: boolean;
};

export const NftPackageParamRow = ({ label, value, withIcon }: NftPackageParamRowProps) => {
  const isDesktop = useScreenSize() > ScreenSize.medium;
  const textSizeClassName = '!tw-text-[10px] lg:!tw-text-[16px]';
  return (
    <div className="twxw-overflow-hidden tw-rounded-md tw-bg-[#112D68]">
      <NftCardLabelPanel label={label} size={isDesktop ? 'lg' : 'base'} className={textSizeClassName}>
        <div className="tw-flex tw-flex-row tw-items-center tw-gap-1">
          {withIcon && <img src={RMV} alt="rmv icon" className="tw-h-4 tw-w-4" />}
          <span className={twMerge('tw-text-base tw-text-white', textSizeClassName)}>{value}</span>
        </div>
      </NftCardLabelPanel>
    </div>
  );
};
